<template>
  <section class="z-10">
    <div class="navbar z-10">
      <div
        id="click"
        v-if="isEarnVisible"
        class="absolute w-full h-full"
        @click="toggleDropdownOff"
      ></div>
      <div
        id="click"
        v-if="isMoreVisible"
        class="absolute w-full h-full"
        @click="toggleDropdownOff"
      ></div>

      <!--  -->
      <div class="w-full h-14 my-0.5 py-2 flex flex-row top-0 relative">
        <div class="w-[50%] flex flex-row items-center pl-2">
          <router-link :key="$route.path" to="/">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 908 228"
              style="
                enable-background: new 0 0 908 228;
                width: 127;
                height: 32px;
                margin-left: 10px;
              "
              xml:space="preserve"
            >
              <defs><path id="a" d="M13.4 10.8H983v212.4H13.4z" /></defs>
              <clipPath id="b">
                <use xlink:href="#a" style="overflow: visible" />
              </clipPath>
              <path
                style="clip-path: url(#b); fill: #fff"
                d="M83.8 161.7c-14.4-6.6-22.9-24.8-13.2-40.4 1.8-2.7 4.1-5 6.2-7.3 5.8-6 10.9-11.3 5.6-21.4-3.7-6.9-14.3-9.2-20.7-4.6-59.4 46.2-22.4 86.9 12.5 125.1 2.5 2.7 4.9 5.4 7.3 8 1.2 1.3 1.7 2 2.2 2v-61.4h.1z"
              />
              <defs><path id="c" d="M13.4 10.8H983v212.4H13.4z" /></defs>
              <clipPath id="d">
                <use xlink:href="#c" style="overflow: visible" />
              </clipPath>
              <path
                style="clip-path: url(#d); fill: #fff"
                d="M83.8 223.3c.6 0 1.2-.6 2.7-1.9 7.6-6.9 15.3-13.7 22.9-20.6 13.1-11.8 26.1-23.5 39.1-35.2 5.2-4.6 6.6-12.7 3.2-18-9.9-16-22.4-4.2-31.9 4.8-1.4 1.3-2.7 2.6-4 3.6-10.8 9.4-22.7 10.1-32.1 5.7v61.6h.1z"
              />
              <defs><path id="e" d="M13.4 10.8H983v212.4H13.4z" /></defs>
              <clipPath id="f">
                <use xlink:href="#e" style="overflow: visible" />
              </clipPath>
              <path
                style="clip-path: url(#f); fill: #fff"
                d="M19.5 70c6.9-6.2 13.8-12.4 20.6-18.6l41.4-37.2c.3-.3.6-.5.8-.7.3-.3.6-.5.8-.7.1-.1.2-.2.3-.2l.2.2.7.7c.2.2.4.5.7.8 2.4 2.7 4.9 5.4 7.3 8.1 6.9 7.5 13.8 15.1 20.1 22.9 8.5 10.5 15.7 21.1 19.8 32 4.1 10.8 5.1 21.9 1.2 33.2-3.9 11.4-12.7 23.2-28.5 35.5-2.9 2.1-6.8 2.6-10.5 1.8s-7-2.9-8.6-6.1c-1.8-3.3-2.3-6-2.1-8.4.2-2.3 1.2-4.4 2.7-6.4 1.3-1.8 3-3.6 4.8-5.5.2-.2.4-.4.5-.6 2-2.1 4.1-4.3 5.8-6.8 16.7-26.8-18.4-60.7-46.7-36-1.2 1.1-2.5 2.3-3.9 3.6l-.1.1c-1.3 1.3-2.7 2.6-4.1 3.8-2.9 2.6-6 5-9 6.6s-6 2.3-8.8 1.7c-2.8-.7-5.6-2.7-8.4-7.2-3.1-4.8-1.8-12.4 3-16.6"
              />
              <defs><path id="g" d="M13.4 10.8H983v212.4H13.4z" /></defs>
              <clipPath id="h">
                <use xlink:href="#g" style="overflow: visible" />
              </clipPath>
              <path
                style="clip-path: url(#h); fill: #fff"
                d="M19.5 70c6.9-6.2 13.8-12.4 20.6-18.6l41.4-37.2c.3-.3.6-.5.8-.7.3-.3.6-.5.8-.7.1-.1.2-.2.3-.2l.2.2.7.7c.2.2.4.5.7.8 2.4 2.7 4.9 5.4 7.3 8.1 6.9 7.5 13.8 15.1 20.1 22.9 8.5 10.5 15.7 21.1 19.8 32 4.1 10.8 5.1 21.9 1.2 33.2-3.9 11.4-12.7 23.2-28.5 35.5-2.9 2.1-6.8 2.6-10.5 1.8s-7-2.9-8.6-6.1c-1.8-3.3-2.3-6-2.1-8.4.2-2.3 1.2-4.4 2.7-6.4 1.3-1.8 3-3.6 4.8-5.5.2-.2.4-.4.5-.6 2-2.1 4.1-4.3 5.8-6.8 16.7-26.8-18.4-60.7-46.7-36-1.2 1.1-2.5 2.3-3.9 3.6l-.1.1c-1.3 1.3-2.7 2.6-4.1 3.8-2.9 2.6-6 5-9 6.6s-6 2.3-8.8 1.7c-2.8-.7-5.6-2.7-8.4-7.2-3.1-4.8-1.8-12.4 3-16.6z"
              />
              <path
                d="M248.3 84.3c-3 4.5-7.1 7.9-12.3 10.2-5.2 2.3-11 3.4-17.4 3.4h-14.2v25.4h-18.6V38.6h34.6c6.6 0 12.4 1.2 17.2 3.7 4.9 2.5 8.6 5.9 11.3 10.3 2.6 4.4 3.9 9.5 3.9 15.2v.2c0 6.4-1.5 11.8-4.5 16.3zm-18.4-25.6c-2.7-2.2-6.4-3.3-11.1-3.3h-14.4v25.9h14.8c4.5 0 8.1-1.2 10.8-3.6s4-5.5 4-9.2v-.2c-.1-4.2-1.4-7.3-4.1-9.6zm83.5 45.6h-35.8l-7.7 19h-19L287.2 38h17.2l36.3 85.3h-19.5l-7.8-19zm-29.1-16.5h22.5l-11.3-27.5-11.2 27.5zm69.4-49.2h18.6v67.8h42.2v16.9h-60.9l.1-84.7zM494.8 68 471 104.2h-.5l-23.6-35.8v54.9h-18.3V38.6h20.1L471 74.4l22.3-35.8h20.1v84.7h-18.5l-.1-55.3zm91.5 49.6c-5.7 4.6-13.2 7-22.6 7-6.5 0-12.9-1.1-19.1-3.4-6.2-2.3-11.8-5.7-16.8-10.1l11-13.2c4 3.3 8.1 5.8 12.2 7.6 4.1 1.8 8.5 2.7 13.1 2.7 3.8 0 6.8-.7 9-2.1 2.2-1.4 3.3-3.4 3.3-5.9v-.2c0-1.7-.4-3.1-1.3-4.2s-2.6-2.2-5-3.2c-2.5-1-6-2.1-10.7-3.3-6.5-1.7-11.6-3.4-15.5-5.3-3.9-1.8-7-4.4-9.2-7.6s-3.3-7.6-3.3-13v-.2c0-5.1 1.3-9.5 3.8-13.4 2.5-3.8 6.1-6.8 10.5-9 4.5-2.1 9.6-3.2 15.3-3.2 12 0 22.5 3.6 31.5 10.8l-9.7 14c-8-5.6-15.3-8.3-22-8.3-3.5 0-6.2.7-8 2.1-1.9 1.4-2.8 3.1-2.8 5.3v.2c0 1.9.5 3.4 1.5 4.5 1 1.2 2.8 2.2 5.3 3.2s6.3 2.1 11.5 3.4c9.2 2.4 16 5.5 20.3 9.3s6.5 9.1 6.5 16.2v.2c-.2 8-3.1 14.4-8.8 19.1zm98.6 6.3-19.1-55.4-19.1 55.4h-16.2l-28.9-85.3h20L639 96l19-57.6h16L693 96l17.5-57.4H730l-28.9 85.3h-16.2zm103.3-19.6h-35.8l-7.7 19h-19L762 38h17.2l36.3 85.3H796l-7.8-19zm-29.1-16.5h22.5l-11.3-27.5-11.2 27.5zM891 84.3c-3 4.5-7.1 7.9-12.3 10.2-5.2 2.3-11 3.4-17.4 3.4h-14.2v25.4h-18.6V38.6h34.6c6.6 0 12.4 1.2 17.2 3.7 4.9 2.5 8.6 5.9 11.3 10.3 2.6 4.4 3.9 9.5 3.9 15.2v.2c0 6.4-1.5 11.8-4.5 16.3zm-18.3-25.6c-2.7-2.2-6.4-3.3-11.1-3.3h-14.4v25.9H862c4.5 0 8.1-1.2 10.8-3.6s4-5.5 4-9.2v-.2c-.1-4.2-1.5-7.3-4.1-9.6zM213 195l-4.3-12.4h-17.2l-4.3 12.4h-7.7l16.5-45h8.1l16.5 45H213zm-6.3-18.7-4.3-12.2c-.2-.5-.5-1.4-.7-2.3-.2-.9-.7-2-.9-2.9-.2-.9-.5-1.8-.7-2.5-.2.9-.5 1.8-.7 2.7-.2.9-.7 2-.9 2.9-.2.9-.5 1.6-.7 2l-4.3 12.2h13.2zm45.2-20.4c-2 0-4.1.5-5.7 1.1s-3.2 1.8-4.3 3.4c-1.1 1.6-2 3.2-2.7 5.2s-.9 4.3-.9 7c0 3.4.5 6.6 1.4 9 .9 2.5 2.5 4.5 4.5 5.7s4.5 2 7.7 2c1.8 0 3.8-.2 5.4-.5 1.8-.5 3.6-.9 5.7-1.6v6.3c-1.8.7-3.6 1.1-5.4 1.6-1.8.2-4.1.5-6.3.5-4.5 0-8.4-.9-11.3-2.9-2.9-1.8-5.2-4.5-6.8-7.9-1.6-3.4-2.3-7.5-2.3-12.2 0-3.4.5-6.6 1.4-9.3.9-2.7 2.3-5.2 4.1-7.2 1.8-2 4.1-3.6 6.6-4.7 2.7-1.1 5.7-1.6 9-1.6 2.3 0 4.5.2 6.6.7 2.3.5 4.3 1.1 6.1 2l-2.5 6.1c-1.6-.7-3.2-1.4-5-1.8-1.7-.6-3.5-.9-5.3-.9zm54.7 39.1-4.3-12.4h-17.2l-4.3 12.4h-7.7l16.7-45h8.1l16.5 45h-7.8zm-6.3-18.7-4.3-12.2c-.2-.5-.5-1.4-.7-2.3-.2-.9-.7-2-.9-2.9-.2-.9-.5-1.8-.7-2.5-.2.9-.5 1.8-.7 2.7-.2.9-.7 2-.9 2.9-.2.9-.5 1.6-.7 2l-4.3 12.2h13.2zm62.6-4.1c0 5-.9 9.3-2.7 12.7-1.8 3.4-4.5 5.9-8.1 7.7-3.6 1.8-7.9 2.5-12.9 2.5h-12.4v-44.8h13.8c4.5 0 8.6.9 12 2.5 3.4 1.6 5.9 4.1 7.7 7.5 1.7 3.1 2.6 7.2 2.6 11.9zm-7.7.2c0-3.6-.7-6.8-1.8-9-1.1-2.3-2.9-4.1-5-5.2-2.3-1.1-5-1.8-8.1-1.8H334v32.5h5.2c5.4 0 9.5-1.4 12.2-4.1 2.7-2.6 3.8-6.9 3.8-12.4zM404 195h-25.3v-44.8H404v6.1h-18.1v12.2h17v6.1h-17v14H404v6.4zm35.3 0-12.9-37.3h-.2c0 .9.2 2 .2 3.4s.2 2.9.2 4.7V195H420v-44.8h10.4l12.4 35.7h.2l12.9-35.7h10.2V195h-7v-29.4c0-1.6 0-3.2.2-4.5 0-1.4.2-2.5.2-3.4h-.2L446.1 195h-6.8zm57.2-24.4 10.6-20.3h7.9l-14.9 27.3V195h-7.2v-17.2L478 150.2h7.9l10.6 20.4z"
                style="fill: #fff"
              />
            </svg>
          </router-link>
          <a href="/">
            <p
              class="sm:hidden ml-3 md:flex px-3 py-2 text-[#6C7284] cursor-pointer text-[14px] hover:text-white"
            >
              Home
            </p>
          </a>

          <a href="#" @click.prevent="emitScrollEvent" target="_blank">
            <p
              class="sm:hidden md:flex px-3 py-2 text-[#6C7284] cursor-pointer text-[14px] hover:text-white"
            >
              Explore
            </p>
          </a>

          <div
            @click="toggleEarnDropdown"
            id="earn"
            class="px-3 sm:hidden md:flex relative flex items-center text-[#6C7284] fill-[#6C7284] hover:text-white hover:fill-white"
          >
            <p class="py-2 pr-1 cursor-pointer text-[14px]">Topics</p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              aria-hidden="true"
              class="h-4 cursor-pointer"
            >
              <path
                fill-rule="evenodd"
                d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                clip-rule="evenodd"
              ></path>
            </svg>
            <div
              v-if="isEarnVisible"
              class="earndropdown border-2 border-border p-2 top-10 bg-[#14151a] w-[160px] absolute h-[170px] rounded-lg items-center flex flex-col"
            >
              <a
                href="https://app.palmswap.org/earn/staking"
                class="w-full"
                target="_blank"
              >
                <div
                  class="w-full cursor-pointer rounded-lg flex pl-3 text-[12px] text-graytext items-center justify-items-start h-[34px] hover:bg-[#191b1f]"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                    class="h-4"
                  >
                    <path
                      d="M3.196 12.87l-.825.483a.75.75 0 000 1.294l7.25 4.25a.75.75 0 00.758 0l7.25-4.25a.75.75 0 000-1.294l-.825-.484-5.666 3.322a2.25 2.25 0 01-2.276 0L3.196 12.87z"
                    ></path>
                    <path
                      d="M3.196 8.87l-.825.483a.75.75 0 000 1.294l7.25 4.25a.75.75 0 00.758 0l7.25-4.25a.75.75 0 000-1.294l-.825-.484-5.666 3.322a2.25 2.25 0 01-2.276 0L3.196 8.87z"
                    ></path>
                    <path
                      d="M10.38 1.103a.75.75 0 00-.76 0l-7.25 4.25a.75.75 0 000 1.294l7.25 4.25a.75.75 0 00.76 0l7.25-4.25a.75.75 0 000-1.294l-7.25-4.25z"
                    ></path>
                  </svg>
                  <button class="ml-1">Staking</button>
                </div>
              </a>
              <a
                href="https://app.palmswap.org/earn/farm"
                class="w-full"
                target="_blank"
              >
                <div
                  class="w-full cursor-pointer mt-1 rounded-lg flex pl-3 text-[12px] text-graytext items-center justify-items-start h-[34px] hover:bg-[#191b1f]"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    version="1.1"
                    x="0px"
                    y="0px"
                    width="15px"
                    height="15px"
                    viewBox="0 0 1000 1000"
                    enable-background="new 0 0 1000 1000"
                    xml:space="preserve"
                  >
                    <metadata fill="#6c7284"></metadata>

                    <path
                      d="M940.7,424.1h-38V266.5l-0.6-5.4c0-0.2-2.9-14.9,4.5-24c7.5-9.2,24-11.1,36.6-11.1c13.7,0,24.6-11.1,24.6-24.6s-11-24.6-24.6-24.6c-34.3,0-59.7,10.1-75.4,30c-18.8,23.7-16.1,52.2-14.4,62.1v155.3H603.7L492.8,161.8c-20.4-50.1-51.1-86.3-98.6-86.3H153.8c-47.5,0-86.3,38.7-86.3,86.3v318.2L82,465.4c19.2-19.2,45.3-29.2,72.3-28.8c18-19.3,43.7-31,71.9-31h49.3c28.2,0,53.8,11.7,71.9,31c27.1-0.5,53.1,9.6,72.3,28.8l34.8,34.8c19.6,19.5,29.4,46.1,28.7,72.6c19.2,18.2,31.1,43.9,31.1,71.7v45.2H669c-23.4,25-37.9,58.4-37.9,95.3c0,76.8,62.5,139.5,139.5,139.5c76.8,0,139.5-62.6,139.5-139.5c0-37.2-14.7-70.8-38.3-95.8c27.5-2.3,68.9-23.2,68.9-48.7L990,473.5C989.9,446.1,967.8,424.1,940.7,424.1z M142.4,364.1V189.7c0-31.6,25.7-57.2,57.2-57.2h159.3c31.5,0,51.9,24,65.4,57.2l73.5,175.1L142.4,364.1z M770.5,850.5c-36.1,0-65.5-29.4-65.5-65.5c0-36.2,29.4-65.5,65.5-65.5S836,748.9,836,785C836,821.1,806.6,850.5,770.5,850.5z"
                      fill="#6c7284"
                    />
                    <path
                      d="M426.2,539.3l-31-31c-17.1-17.2-40.3-26.2-64.5-25.7c-16.1-17.2-38.9-27.6-64.1-27.6h-43.9c-25.1,0-47.9,10.4-64,27.6c-24-0.5-47.3,8.5-64.5,25.7l-31.1,31c-17.8,17.8-26.6,41.4-25.8,65c-17,16.2-27.4,39-27.4,63.5v43.9c0,24.5,10.5,47.3,27.4,63.6c-0.8,23.6,8,47.1,25.8,64.9l31,31c17.1,17.2,40.4,26.4,64.5,25.7c16.1,17.2,38.9,27.6,64,27.6h43.9c25.1,0,47.9-10.4,64.1-27.6c24.2,0.8,47.3-8.5,64.5-25.7l31-31c17.4-17.4,26.2-41.1,25.6-64.7c17.1-16.2,27.7-39.2,27.7-63.9v-43.9c0-24.7-10.6-47.5-27.7-63.8C452.4,580.3,443.6,556.7,426.2,539.3z M244.7,836.6c-81,0-146.9-65.9-146.9-146.9s65.9-146.9,146.9-146.9c81,0,146.9,65.9,146.9,146.9S325.6,836.6,244.7,836.6z"
                      fill="#6c7284"
                    />
                    <circle cx="244.7" cy="689.7" r="81" fill="#6c7284" />
                  </svg>
                  <button class="ml-1">Farm</button>
                </div>
              </a>
              <a
                href="https://app.palmswap.org/claim"
                class="w-full"
                target="_blank"
              >
                <div
                  class="w-full cursor-pointer mt-1 rounded-lg flex pl-3 text-[12px] text-graytext items-center justify-items-start h-[34px] hover:bg-[#191b1f]"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-hidden="true"
                    class="h-4"
                  >
                    <path
                      d="M12 1.5a.75.75 0 01.75.75V7.5h-1.5V2.25A.75.75 0 0112 1.5zM11.25 7.5v5.69l-1.72-1.72a.75.75 0 00-1.06 1.06l3 3a.75.75 0 001.06 0l3-3a.75.75 0 10-1.06-1.06l-1.72 1.72V7.5h3.75a3 3 0 013 3v9a3 3 0 01-3 3h-9a3 3 0 01-3-3v-9a3 3 0 013-3h3.75z"
                    ></path>
                  </svg>
                  <button class="ml-1">Claim</button>
                </div>
              </a>

              <a
                href="https://app.palmswap.org/launchpad"
                class="w-full"
                target="_blank"
              >
                <div
                  class="w-full cursor-pointer mt-1 rounded-lg flex pl-3 text-[12px] text-graytext items-center justify-items-start h-[34px] hover:bg-[#191b1f]"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-hidden="true"
                    class="h-4"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M3 6a3 3 0 013-3h2.25a3 3 0 013 3v2.25a3 3 0 01-3 3H6a3 3 0 01-3-3V6zm9.75 0a3 3 0 013-3H18a3 3 0 013 3v2.25a3 3 0 01-3 3h-2.25a3 3 0 01-3-3V6zM3 15.75a3 3 0 013-3h2.25a3 3 0 013 3V18a3 3 0 01-3 3H6a3 3 0 01-3-3v-2.25zm9.75 0a3 3 0 013-3H18a3 3 0 013 3V18a3 3 0 01-3 3h-2.25a3 3 0 01-3-3v-2.25z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>

                  <button class="ml-1">Launchpad</button>
                </div>
              </a>
            </div>
          </div>

          <div
            @click="toggleMoreDropdown"
            id="earn"
            class="px-3 sm:hidden md:flex relative flex items-center text-[#6C7284] fill-[#6C7284] hover:text-white hover:fill-white"
          >
            <p class="py-2 pr-1 cursor-pointer text-[14px]">Trading</p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              aria-hidden="true"
              class="h-4 cursor-pointer"
            >
              <path
                fill-rule="evenodd"
                d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                clip-rule="evenodd"
              ></path>
            </svg>
            <div
              v-if="isMoreVisible"
              class="moredropdown border-2 border-border justify-items-start p-2 top-10 bg-[#14151a] w-[409px] absolute h-[226px] rounded-lg flex flex-wrap flex-col"
            >
              <a
                href="https://docs.palmswap.org"
                class="w-[50%]"
                target="_blank"
              >
                <div
                  class="w-[100%] cursor-pointer rounded-lg flex pl-3 text-[12px] text-graytext items-center justify-items-start h-[34px] hover:bg-[#191b1f]"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                    class="h-4"
                  >
                    <path
                      d="M3.196 12.87l-.825.483a.75.75 0 000 1.294l7.25 4.25a.75.75 0 00.758 0l7.25-4.25a.75.75 0 000-1.294l-.825-.484-5.666 3.322a2.25 2.25 0 01-2.276 0L3.196 12.87z"
                    ></path>
                    <path
                      d="M3.196 8.87l-.825.483a.75.75 0 000 1.294l7.25 4.25a.75.75 0 00.758 0l7.25-4.25a.75.75 0 000-1.294l-.825-.484-5.666 3.322a2.25 2.25 0 01-2.276 0L3.196 8.87z"
                    ></path>
                    <path
                      d="M10.38 1.103a.75.75 0 00-.76 0l-7.25 4.25a.75.75 0 000 1.294l7.25 4.25a.75.75 0 00.76 0l7.25-4.25a.75.75 0 000-1.294l-7.25-4.25z"
                    ></path>
                  </svg>
                  <button class="ml-1">Documentation</button>
                </div>
              </a>
              <a
                href="https://palmswap.org/referral_agreement"
                class="w-[50%] whitespace-nowrap"
                target="_blank"
              >
                <div
                  class="w-[100%] cursor-pointer mt-1 rounded-lg flex pl-3 text-[12px] text-graytext items-center justify-items-start h-[34px] hover:bg-[#191b1f]"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                    class="h-4"
                    role="none"
                  >
                    <path
                      d="M3 3.5A1.5 1.5 0 014.5 2h6.879a1.5 1.5 0 011.06.44l4.122 4.12A1.5 1.5 0 0117 7.622V16.5a1.5 1.5 0 01-1.5 1.5h-11A1.5 1.5 0 013 16.5v-13z"
                      role="none"
                    ></path>
                  </svg>
                  <button class="ml-1">Referral Agreement</button>
                </div>
              </a>

              <a href="https://palmswap.org/terms_of_use" target="_blank">
                <div
                  class="w-[100%] whitespace-nowrap cursor-pointer mt-1 rounded-lg flex pl-3 text-[12px] text-graytext items-center justify-items-start h-[34px] hover:bg-[#191b1f]"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                    class="h-4"
                    role="none"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M4.5 2A1.5 1.5 0 003 3.5v13A1.5 1.5 0 004.5 18h11a1.5 1.5 0 001.5-1.5V7.621a1.5 1.5 0 00-.44-1.06l-4.12-4.122A1.5 1.5 0 0011.378 2H4.5zm2.25 8.5a.75.75 0 000 1.5h6.5a.75.75 0 000-1.5h-6.5zm0 3a.75.75 0 000 1.5h6.5a.75.75 0 000-1.5h-6.5z"
                      clip-rule="evenodd"
                      role="none"
                    ></path>
                  </svg>
                  <p class="ml-1">Terms of Service</p>
                </div>
              </a>

              <a
                href="https://palmswap.org/privacy"
                class="w-[50%]"
                target="_blank"
              >
                <div
                  class="w-[100%] cursor-pointer mt-1 rounded-lg flex pl-3 text-[12px] text-graytext items-center justify-items-start h-[34px] hover:bg-[#191b1f]"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                    class="h-4"
                    role="none"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10.339 2.237a.532.532 0 00-.678 0 11.947 11.947 0 01-7.078 2.75.5.5 0 00-.479.425A12.11 12.11 0 002 7c0 5.163 3.26 9.564 7.834 11.257a.48.48 0 00.332 0C14.74 16.564 18 12.163 18 7.001c0-.54-.035-1.07-.104-1.59a.5.5 0 00-.48-.425 11.947 11.947 0 01-7.077-2.75zM10 6a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 6zm0 9a1 1 0 100-2 1 1 0 000 2z"
                      clip-rule="evenodd"
                      role="none"
                    ></path>
                  </svg>
                  <button class="ml-1">Privacy Policy</button>
                </div>
              </a>

              <a
                href="      https://web3.career/web3-companies/palmswap"
                class="w-[50%]"
                target="_blank"
              >
                <div
                  class="w-[100%] cursor-pointer mt-1 rounded-lg flex pl-3 text-[12px] text-graytext items-center justify-items-start h-[34px] hover:bg-[#191b1f]"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                    class="h-4"
                    role="none"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M6 3.75A2.75 2.75 0 018.75 1h2.5A2.75 2.75 0 0114 3.75v.443c.572.055 1.14.122 1.706.2C17.053 4.582 18 5.75 18 7.07v3.469c0 1.126-.694 2.191-1.83 2.54-1.952.599-4.024.921-6.17.921s-4.219-.322-6.17-.921C2.694 12.73 2 11.665 2 10.539V7.07c0-1.321.947-2.489 2.294-2.676A41.047 41.047 0 016 4.193V3.75zm6.5 0v.325a41.622 41.622 0 00-5 0V3.75c0-.69.56-1.25 1.25-1.25h2.5c.69 0 1.25.56 1.25 1.25zM10 10a1 1 0 00-1 1v.01a1 1 0 001 1h.01a1 1 0 001-1V11a1 1 0 00-1-1H10z"
                      clip-rule="evenodd"
                      role="none"
                    ></path>
                    <path
                      d="M3 15.055v-.684c.126.053.255.1.39.142 2.092.642 4.313.987 6.61.987 2.297 0 4.518-.345 6.61-.987.135-.041.264-.089.39-.142v.684c0 1.347-.985 2.53-2.363 2.686a41.454 41.454 0 01-9.274 0C3.985 17.585 3 16.402 3 15.055z"
                      role="none"
                    ></path>
                  </svg>

                  <button class="ml-1">Career</button>
                </div>
              </a>

              <a
                href="     https://palmswap.canny.io/"
                class="w-[50%]"
                target="_blank"
              >
                <div
                  class="w-[100%] cursor-pointer mt-1 rounded-lg flex pl-3 text-[12px] text-graytext items-center justify-items-start h-[34px] hover:bg-[#191b1f]"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                    class="h-4"
                    role="none"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 2c-2.236 0-4.43.18-6.57.524C1.993 2.755 1 4.014 1 5.426v5.148c0 1.413.993 2.67 2.43 2.902 1.168.188 2.352.327 3.55.414.28.02.521.18.642.413l1.713 3.293a.75.75 0 001.33 0l1.713-3.293a.783.783 0 01.642-.413 41.102 41.102 0 003.55-.414c1.437-.231 2.43-1.49 2.43-2.902V5.426c0-1.413-.993-2.67-2.43-2.902A41.289 41.289 0 0010 2zM6.75 6a.75.75 0 000 1.5h6.5a.75.75 0 000-1.5h-6.5zm0 2.5a.75.75 0 000 1.5h3.5a.75.75 0 000-1.5h-3.5z"
                      clip-rule="evenodd"
                      role="none"
                    ></path>
                  </svg>

                  <button class="ml-1">Feedback</button>
                </div>
              </a>
              <div
                class="w-[50%] cursor-pointer mt-1 rounded-lg flex pl-3 text-[12px] text-graytext items-center justify-items-start h-[34px] hover:bg-[#191b1f]"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                  class="h-4"
                  role="none"
                >
                  <path
                    fill-rule="evenodd"
                    d="M2 3.5A1.5 1.5 0 013.5 2h9A1.5 1.5 0 0114 3.5v11.75A2.75 2.75 0 0016.75 18h-12A2.75 2.75 0 012 15.25V3.5zm3.75 7a.75.75 0 000 1.5h4.5a.75.75 0 000-1.5h-4.5zm0 3a.75.75 0 000 1.5h4.5a.75.75 0 000-1.5h-4.5zM5 5.75A.75.75 0 015.75 5h4.5a.75.75 0 01.75.75v2.5a.75.75 0 01-.75.75h-4.5A.75.75 0 015 8.25v-2.5z"
                    clip-rule="evenodd"
                    role="none"
                  ></path>
                  <path
                    d="M16.5 6.5h-1v8.75a1.25 1.25 0 102.5 0V8a1.5 1.5 0 00-1.5-1.5z"
                    role="none"
                  ></path>
                </svg>

                <button class="ml-1">Blog</button>
              </div>

              <a
                href="https://linktr.ee/palmswap"
                class="w-[50%]"
                target="_blank"
              >
                <div
                  class="w-[100%]cursor-pointer mt-1 rounded-lg flex pl-3 text-[12px] text-graytext items-center justify-items-start h-[34px] hover:bg-[#191b1f]"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                    class="h-4"
                    role="none"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 1a.75.75 0 01.75.75v1.5a.75.75 0 01-1.5 0v-1.5A.75.75 0 0110 1zM5.05 3.05a.75.75 0 011.06 0l1.062 1.06A.75.75 0 116.11 5.173L5.05 4.11a.75.75 0 010-1.06zm9.9 0a.75.75 0 010 1.06l-1.06 1.062a.75.75 0 01-1.062-1.061l1.061-1.06a.75.75 0 011.06 0zM3 8a.75.75 0 01.75-.75h1.5a.75.75 0 010 1.5h-1.5A.75.75 0 013 8zm11 0a.75.75 0 01.75-.75h1.5a.75.75 0 010 1.5h-1.5A.75.75 0 0114 8zm-6.828 2.828a.75.75 0 010 1.061L6.11 12.95a.75.75 0 01-1.06-1.06l1.06-1.06a.75.75 0 011.06 0zm3.594-3.317a.75.75 0 00-1.37.364l-.492 6.861a.75.75 0 001.204.65l1.043-.799.985 3.678a.75.75 0 001.45-.388l-.978-3.646 1.292.204a.75.75 0 00.74-1.16l-3.874-5.764z"
                      clip-rule="evenodd"
                      role="none"
                    ></path>
                  </svg>

                  <button class="ml-1">Social Media</button>
                </div>
              </a>

              <a href="" class="w-[50%]">
                <div
                  class="w-[100%] cursor-pointer mt-1 rounded-lg flex pl-3 text-[12px] text-graytext items-center justify-items-start h-[34px] hover:bg-[#191b1f]"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                    class="h-4"
                    role="none"
                  >
                    <path
                      d="M15.5 2A1.5 1.5 0 0014 3.5v13a1.5 1.5 0 001.5 1.5h1a1.5 1.5 0 001.5-1.5v-13A1.5 1.5 0 0016.5 2h-1zM9.5 6A1.5 1.5 0 008 7.5v9A1.5 1.5 0 009.5 18h1a1.5 1.5 0 001.5-1.5v-9A1.5 1.5 0 0010.5 6h-1zM3.5 10A1.5 1.5 0 002 11.5v5A1.5 1.5 0 003.5 18h1A1.5 1.5 0 006 16.5v-5A1.5 1.5 0 004.5 10h-1z"
                      role="none"
                    ></path>
                  </svg>

                  <button class="ml-1">Status</button>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div class="flex w-[50%] justify-items-end">
          <div
            class="ml-auto flex justify-items-end flex-nowrap items-center pr-3"
          >
            <a href="https://synthetic.palmswap.org/">
              <button
                class="bg-gradient-to-r from-[#9a79e7] to-[#7259d2] text-[14px] flex flex-row flex-wrap py-2 px-6 text-center rounded-[500px] whitespace-nowrap"
              >
                Start Trading
              </button>
            </a>

            <button
              @click="isSidebarToggle = true"
              ref="openSidebar"
              class="text-[14px] bg-[#191B1F] sm:flex md:hidden w-[35px] h-[35px] justify-center items-center rounded-full ml-2"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15">
                <path
                  d="M 2.25 3.75 C 2.25 3.336 2.586 3 3 3 L 12 3 C 12.414 3 12.75 3.336 12.75 3.75 C 12.75 4.164 12.414 4.5 12 4.5 L 3 4.5 C 2.586 4.5 2.25 4.164 2.25 3.75 Z M 2.25 7.5 C 2.25 7.086 2.586 6.75 3 6.75 L 12 6.75 C 12.414 6.75 12.75 7.086 12.75 7.5 C 12.75 7.914 12.414 8.25 12 8.25 L 3 8.25 C 2.586 8.25 2.25 7.914 2.25 7.5 Z M 6.75 11.25 C 6.75 10.836 7.086 10.5 7.5 10.5 L 12 10.5 C 12.414 10.5 12.75 10.836 12.75 11.25 C 12.75 11.664 12.414 12 12 12 L 7.5 12 C 7.086 12 6.75 11.664 6.75 11.25 Z"
                  fill="rgb(108, 114, 132)"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="line w-[100%] h-[2px] bg-box ml-auto mr-auto"></div>

    <div
      class="sidebar md:hidden fixed h-full z-100 h-[100%] overflow-hidden bg-[#14151a]"
      :class="{ sidebarOpen: isSidebarToggle }"
      ref="sidebar"
    >
      <div class="absolute inset-0 opacity-50 mix-blend-overlay"></div>

      <div class="absolute inset-0 overflow-y-auto h-full z-10">
        <div class="top flex flex-row h-[55px] items-center">
          <div class="logo flex pl-2 w-1/2 h-full items-center">
            <svg
              version="1.1"
              id="Ebene_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0"
              y="0"
              class="w-[107px] h-[37px] ml-2"
              viewBox="0 0 406 140"
              style="enable-background: new 0 0 406 140"
              xml:space="preserve"
            >
              <defs><path id="SVGID_1_" d="M11.9 11H399v84.8H11.9z" /></defs>
              <clipPath
                id="SVGID_00000007424117224263025210000004944680610884186758_"
              >
                <use xlink:href="#SVGID_1_" style="overflow: visible" />
              </clipPath>
              <path
                style="
                  clip-path: url(#SVGID_00000007424117224263025210000004944680610884186758_);
                  fill: #fff;
                "
                d="M115.7 50.6c0 7.8-5.3 13.2-14.9 13.2h-3.5v12.1c0 .5-.3.8-.8.8h-7.9c-.5 0-.8-.3-.8-.8V38.3c0-.5.3-.8.8-.8h12.2c9.7-.1 14.9 5.3 14.9 13.1zm-9.1 0c0-3.8-3.2-4.8-5.9-4.8h-3.3v9.5h3.3c2.7.1 5.9-.9 5.9-4.7zM152 76.7h-8.3c-.4 0-.8-.2-1-.7l-1.8-5.7H128l-1.8 5.7c-.2.5-.5.7-1 .7H117c-.6 0-.9-.4-.7-1l13.5-37.6c.2-.4.5-.7 1-.7h7.2c.4 0 .9.2 1.1.7l13.6 37.6c.2.6-.1 1-.7 1zm-13.7-14.5-3.9-12.1-3.9 12.1h7.8zm43 6.9v6.7c0 .5-.3.8-.8.8h-20.3c-.5 0-.8-.3-.8-.8V38.3c0-.5.3-.8.8-.8h7.9c.5 0 .8.3.8.8v30h11.5c.6 0 .9.3.9.8zm49.3-30.8v37.6c0 .5-.3.8-.8.8h-7.9c-.5 0-.8-.3-.8-.8V58.6L214.3 76c-.2.4-.6.7-1.1.7h-7c-.4 0-.9-.3-1.1-.7l-6.8-17.3v17.2c0 .5-.3.8-.8.8h-7.9c-.5 0-.8-.3-.8-.8V38.3c0-.5.3-.8.8-.8h8.8c.4 0 .8.2 1 .6l10.3 27.6L220 38c.2-.4.6-.6 1-.6h8.8c.5 0 .8.3.8.9zm35.2 27c0 8.3-7.4 12.1-14 12.1-5.9 0-11.2-3.2-13.8-6.2-.3-.3-.3-.8 0-1.2l4.3-4.9c.3-.4.8-.5 1.2-.1 3 2.3 5.4 3.4 8.5 3.4 2.2 0 4.4-1 4.4-3.2 0-5.4-17.7-3.7-17.7-16.6 0-7.5 6.3-11.5 12.8-11.5 5.2 0 9.1 2.1 12.5 5.2.4.4.4.7.1 1.2l-4.1 5.1c-.3.4-.7.5-1.2.2-2.9-1.8-4.6-2.6-6.9-2.6-2.6 0-3.8 1.4-3.8 2.8 0 5.3 17.7 2.5 17.7 16.3zm62.9-26.9L316.9 76c-.2.4-.6.7-1.1.7h-7.6c-.4 0-.8-.2-.9-.7l-8-24.2-8 24.2c-.2.4-.5.7-1 .7h-7.6c-.4 0-1-.2-1.1-.7L270 38.4c-.2-.6 0-1 .7-1h8.3c.4 0 .8.2 1 .7l6.8 25.8 7.9-25.8c0-.3.2-.5.5-.6h8c.2 0 .4 0 .5.1.2.1.3.3.4.6L312 64l7-25.8c.1-.5.5-.7 1-.7h8.3c.4-.1.6.3.4.9zm33.7 38.3h-8.3c-.4 0-.8-.2-1-.7l-1.8-5.7h-12.9l-1.8 5.7c-.2.5-.5.7-1 .7h-8.3c-.6 0-.9-.4-.7-1l13.6-37.6c.2-.4.5-.7 1-.7h7.2c.4 0 .9.2 1.1.7l13.6 37.6c.2.6-.1 1-.7 1zm-13.6-14.5-3.9-12.1-3.9 12.1h7.8zm48.9-11.6c0 7.8-5.3 13.2-14.9 13.2h-3.5v12.1c0 .5-.3.8-.8.8h-7.9c-.5 0-.8-.3-.8-.8V38.3c0-.5.3-.8.8-.8h12.2c9.6-.1 14.9 5.3 14.9 13.1zm-9.2 0c0-3.8-3.2-4.8-5.9-4.8h-3.3v9.5h3.3c2.7.1 5.9-.9 5.9-4.7z"
              />
              <defs>
                <path
                  id="SVGID_00000179618622520032301540000005370154754881416893_"
                  d="M11.9 11H399v84.8H11.9z"
                />
              </defs>
              <clipPath
                id="SVGID_00000163794757659080437040000003395643517514910631_"
              >
                <use
                  xlink:href="#SVGID_00000179618622520032301540000005370154754881416893_"
                  style="overflow: visible"
                />
              </clipPath>
              <defs>
                <path
                  id="SVGID_00000169534717072917264360000017367255919535276967_"
                  d="M11.9 11H399v84.8H11.9z"
                />
              </defs>
              <clipPath
                id="SVGID_00000059288007805238376920000016411742542635361693_"
              >
                <use
                  xlink:href="#SVGID_00000169534717072917264360000017367255919535276967_"
                  style="overflow: visible"
                />
              </clipPath>
              <defs>
                <path
                  id="SVGID_00000021080992775104468460000015305878416954953379_"
                  d="M11.9 31H399v84.8H11.9z"
                />
              </defs>
              <clipPath
                id="SVGID_00000145027011189046407720000003621798873884208514_"
              >
                <use
                  xlink:href="#SVGID_00000021080992775104468460000015305878416954953379_"
                  style="overflow: visible"
                />
              </clipPath>
              <path
                style="
                  clip-path: url(#SVGID_00000145027011189046407720000003621798873884208514_);
                  fill: #fff;
                "
                d="M14.3 54.6c2.8-2.5 5.5-5 8.2-7.4 5.5-5 11-9.9 16.5-14.9l.3-.3.3-.3.1-.1.1.1.3.3.3.3c1 1.1 2 2.2 2.9 3.2 2.8 3 5.5 6 8 9.1 3.4 4.2 6.3 8.4 7.9 12.8 1.6 4.3 2 8.7.5 13.3-1.6 4.6-5.1 9.3-11.4 14.2-1.2.8-2.7 1-4.2.7-1.5-.3-2.8-1.2-3.4-2.4-.7-1.3-.9-2.4-.8-3.4.1-.9.5-1.8 1.1-2.6.5-.7 1.2-1.4 1.9-2.2l.2-.2c.8-.8 1.6-1.7 2.3-2.7 6.7-10.7-7.3-24.2-18.6-14.4-.5.4-1 .9-1.6 1.4-.5.5-1.1 1-1.6 1.5-1.2 1-2.4 2-3.6 2.6-1.2.6-2.4.9-3.5.7-1.1-.3-2.2-1.1-3.4-2.9-1.2-1.7-.7-4.7 1.2-6.4"
              />
              <defs>
                <path
                  id="SVGID_00000000901163023054935670000009746837414264187814_"
                  d="M11.9 11H399v84.8H11.9z"
                />
              </defs>
              <clipPath
                id="SVGID_00000106857479348259497640000014626614628881585549_"
              >
                <use
                  xlink:href="#SVGID_00000000901163023054935670000009746837414264187814_"
                  style="overflow: visible"
                />
              </clipPath>
              <path
                class="st2"
                d="m244.4 109.4-1.9-5.5h-7.6l-1.9 5.5h-3.4l7.4-19.9h3.6l7.3 19.9h-3.5zm-2.8-8.3-1.9-5.4c-.1-.2-.2-.6-.3-1-.1-.4-.3-.9-.4-1.3-.1-.4-.2-.8-.3-1.1l-.3 1.2c-.1.4-.3.9-.4 1.3-.1.4-.2.7-.3.9l-1.9 5.4h5.8zm20-9c-.9 0-1.8.2-2.5.5s-1.4.8-1.9 1.5c-.5.6-.9 1.4-1.2 2.3-.3.9-.4 1.9-.4 3.1 0 1.5.2 2.9.6 4 .4 1.1 1.1 2 2 2.5s2 .9 3.4.9c.8 0 1.7-.1 2.4-.2.8-.2 1.6-.4 2.5-.7v2.8c-.8.3-1.6.5-2.4.7-.8.1-1.8.2-2.8.2-2 0-3.7-.4-5-1.3-1.3-.8-2.3-2-3-3.5-.7-1.5-1-3.3-1-5.4 0-1.5.2-2.9.6-4.1.4-1.2 1-2.3 1.8-3.2.8-.9 1.8-1.6 2.9-2.1 1.2-.5 2.5-.7 4-.7 1 0 2 .1 2.9.3 1 .2 1.9.5 2.7.9l-1.1 2.7c-.7-.3-1.4-.6-2.2-.8-.7-.3-1.5-.4-2.3-.4zm24.2 17.3-1.9-5.5h-7.6l-1.9 5.5H271l7.4-19.9h3.6l7.3 19.9h-3.5zm-2.8-8.3-1.9-5.4c-.1-.2-.2-.6-.3-1-.1-.4-.3-.9-.4-1.3-.1-.4-.2-.8-.3-1.1l-.3 1.2c-.1.5-.3.9-.4 1.3-.1.4-.2.7-.3.9l-1.9 5.4h5.8zm27.7-1.8c0 2.2-.4 4.1-1.2 5.6-.8 1.5-2 2.6-3.6 3.4s-3.5 1.1-5.7 1.1h-5.5V89.6h6.1c2 0 3.8.4 5.3 1.1s2.6 1.8 3.4 3.3c.8 1.4 1.2 3.2 1.2 5.3zm-3.4.1c0-1.6-.3-3-.8-4s-1.3-1.8-2.2-2.3-2.2-.8-3.6-.8h-2.8v14.4h2.3c2.4 0 4.2-.6 5.4-1.8 1.1-1.3 1.7-3.1 1.7-5.5zm21.6 10h-11.2V89.6h11.2v2.7h-8v5.4h7.5v2.7h-7.5v6.2h8v2.8zm15.6 0-5.7-16.5h-.1c0 .4.1.9.1 1.5s.1 1.3.1 2.1v12.9H336V89.6h4.6l5.5 15.8h.1l5.7-15.8h4.5v19.8h-3.1v-13c0-.7 0-1.4.1-2 0-.6.1-1.1.1-1.5h-.1l-5.9 16.5h-3zm25.3-10.8 4.7-9h3.5l-6.6 12.1v7.7h-3.2v-7.6l-6.6-12.2h3.5l4.7 9zM40 91.2c-5.7-2.6-9.1-9.9-5.3-16.1.7-1.1 1.6-2 2.5-2.9 2.3-2.4 4.4-4.5 2.2-8.5-1.5-2.8-5.7-3.7-8.3-1.8-23.7 18.4-8.9 34.7 5 49.9 1 1.1 2 2.2 2.9 3.2.5.5.7.8.9.8l.1-24.6z"
              />
              <path
                class="st2"
                d="M40 115.8c.2 0 .5-.2 1.1-.8 3-2.8 6.1-5.5 9.1-8.2l15.6-14.1c2.1-1.8 2.6-5.1 1.3-7.2-4-6.4-8.9-1.7-12.7 1.9-.6.5-1.1 1-1.6 1.4-4.3 3.8-9.1 4-12.8 2.3v24.7zM86 100h130v2H86z"
              />
            </svg>
          </div>

          <div class="close w-1/2 justify-end flex align-center">
            <div
              @click="isSidebarToggle = !isSidebarToggle"
              class="items-center mr-[15px] flex justify-center w-[85px] h-[35px] rounded-full bg-[#191B1F] text-[12px] text-[#6C7284]"
            >
              <button class="mr-2">Close</button>
              <div
                class="h-[18px] w-[18px] bg-[#202327] rounded-full flex justify-center items-center"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9">
                  <path
                    d="M 7 0 L 3.5 3.5 L 0 0"
                    transform="translate(0.5 2.5) rotate(-90 3.5 1.75)"
                    fill="transparent"
                    stroke="rgb(108, 114, 132)"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </div>
            </div>
          </div>
        </div>

        <div
          class="line mt-1 w-[290px] h-[2px] bg-[#222222] ml-auto mr-auto"
        ></div>

        <div class="sidebarContent flex items-start pl-4 flex-col">
          <div class="relative flex flex-col justify-start">
            <button class="text-[#6C7284] text-[14px] pt-[20px]">
              <a href="/"> Home </a>
            </button>
          </div>
          <div class="relative flex flex-col justify-center">
            <button
              @click.prevent="emitScrollEvent"
              class="text-[#6C7284] text-[14px] pt-[20px]"
            >
              Explore
            </button>
          </div>
          <div class="relative flex flex-col justify-center">
            <div class="flex flex-row pt-[20px]" @click="activeDropdown()">
              <button
                @click="isEarn = !isEarn"
                class="text-[#6C7284] text-[14px]"
                id="mobileEarn"
              >
                Earn
              </button>

              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="#6C7284"
                class="w-5 h-5"
                id="mobileEarnArrow"
              >
                <path
                  fill-rule="evenodd"
                  d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.168l3.71-3.938a.75.75 0 1 1 1.08 1.04l-4.25 4.5a.75.75 0 0 1-1.08 0l-4.25-4.5a.75.75 0 0 1 .02-1.06z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>

            <transition
              enter-active-class="transition duration-500 ease-out transform"
              enter-class="opacity-0"
              enter-to-class="opacity-100"
              leave-active-class="transition duration-300 ease-in-out transform"
              leave-class="opacity-100"
              leave-to-class="opacity-0"
            >
              <div v-show="isEarn" class="flex w-full">
                <div
                  class="flex flex-col whitespace-nowrap justify-left ml-4 text-left z-10"
                >
                  <a
                    href="https://app.palmswap.org/earn/staking"
                    class="block text-[13px] text-[#6C7284] mt-3"
                  >
                    Staking
                  </a>
                  <a
                    href="https://app.palmswap.org/earn/farm"
                    class="block text-[13px] text-[#6C7284] mt-3"
                  >
                    Farm
                  </a>
                  <a
                    href="https://app.palmswap.org/launchpad"
                    class="block text-[13px] text-[#6C7284] mt-3"
                  >
                    Launchpad
                  </a>
                  <a
                    href="https://app.palmswap.org/claim"
                    class="block text-[13px] text-[#6C7284] mt-3"
                  >
                    Claim
                  </a>
                </div>
              </div>
            </transition>
          </div>
          <div class="relative flex flex-col justify-center">
            <div class="flex flex-row pt-[20px]" @click="activeDropdown()">
              <button
                @click="isMore = !isMore"
                class="text-[#6C7284] text-[14px]"
                id="mobileMore"
              >
                More
              </button>

              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="#6C7284"
                class="w-5 h-5"
                id="mobileMoreArrow"
              >
                <path
                  fill-rule="evenodd"
                  d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.168l3.71-3.938a.75.75 0 1 1 1.08 1.04l-4.25 4.5a.75.75 0 0 1-1.08 0l-4.25-4.5a.75.75 0 0 1 .02-1.06z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>

            <transition
              enter-active-class="transition duration-500 ease-out transform"
              enter-class="opacity-0"
              enter-to-class="opacity-100"
              leave-active-class="transition duration-300 ease-in-out transform"
              leave-class="opacity-100"
              leave-to-class="opacity-0"
            >
              <div v-show="isMore" class="flex w-full">
                <div
                  class="flex flex-col whitespace-nowrap justify-left ml-4 text-left z-10"
                >
                  <a
                    href="https://docs.palmswap.org/"
                    class="block text-[13px] text-[#6C7284] mt-3"
                  >
                    Documentation
                  </a>
                  <a
                    href="https://palmswap.org/referral_agreement"
                    class="block text-[13px] text-[#6C7284] mt-3"
                  >
                    Referral Agreement
                  </a>
                  <a
                    href="https://palmswap.org/terms_of_use"
                    class="block text-[13px] text-[#6C7284] mt-3"
                  >
                    Terms of Service
                  </a>
                  <a
                    href="https://palmswap.org/privacy"
                    class="block text-[13px] text-[#6C7284] mt-3"
                  >
                    Privacy Policy
                  </a>
                  <a
                    href="https://web3.career/web3-companies/palmswap"
                    class="block text-[13px] text-[#6C7284] mt-3"
                  >
                    Career
                  </a>
                  <a
                    href="https://palmswap.canny.io/"
                    class="block text-[13px] text-[#6C7284] mt-3"
                  >
                    Feedback
                  </a>
                  <a
                    href="https://blog.palmswap.org"
                    class="block text-[13px] text-[#6C7284] mt-3"
                  >
                    Blog
                  </a>
                  <a
                    href="https://linktr.ee/palmswap"
                    class="block text-[13px] text-[#6C7284] mt-3"
                  >
                    Social Media
                  </a>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>

      <button
        class="w-[290px] ml-auto mr-auto text-[12px] left-0 right-0 h-[45px] rounded-full py-2 px-6 text-center bg-gradient-to-r from-[#9a79e7] to-[#7259d2] absolute bottom-5"
      >
        <a href="https://synthetic.palmswap.org" target="_blank">
          Start Trading
        </a>
      </button>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      isEarnVisible: false,
      isMoreVisible: false,
      isEarn: false,
      isMore: false,
      isSidebarToggle: false,
    };
  },

  mounted() {
    // Add a click event listener to the document to detect clicks outside the sidebar
    document.addEventListener("click", this.handleDocumentClick);
  },
  beforeUnmount() {
    // Remove the click event listener when the component is unmounted
    document.removeEventListener("click", this.handleDocumentClick);
  },

  methods: {
    activeColor() {
      const earn = document.getElementById("earn");
      if (this.isEarnVisible) {
        earn.style.color = "#ffffff";
      }
    },

    //mobile dropdown

    activeDropdown() {
      const mobileEarn = document.getElementById("mobileEarn");
      const mobileEarnArrow = document.getElementById("mobileEarnArrow");

      const mobileMore = document.getElementById("mobileMore");
      const mobileMoreArrow = document.getElementById("mobileMoreArrow");

      if (this.isEarn === true) {
        mobileEarn.style.color = "#ffffff";
        mobileEarnArrow.style.fill = "#ffffff";
        mobileEarnArrow.style.transform = "rotate(180deg)";
      } else {
        mobileEarn.style.color = "#6C7284";
        mobileEarnArrow.style.fill = "#6C7284";
        mobileEarnArrow.style.transform = "rotate(0deg)";
      }

      if (this.isMore === true) {
        mobileMore.style.color = "#ffffff";
        mobileMoreArrow.style.fill = "#ffffff";
        mobileMoreArrow.style.transform = "rotate(180deg)";
      } else {
        mobileMore.style.color = "#6C7284";
        mobileMoreArrow.style.fill = "#6C7284";
        mobileMoreArrow.style.transform = "rotate(0deg)";
      }
    },
    emitScrollEvent() {
      this.$emit("scroll-to-element");
      this.isSidebarToggle = false;
    },

    toggleDropdownOff() {
      this.isEarnVisible = false;
      this.isMoreVisible = false;
    },
    toggleEarnDropdown() {
      this.isMoreVisible = false;
      this.isEarnVisible = !this.isEarnVisible;
    },
    toggleMoreDropdown() {
      this.isEarnVisible = false;
      this.isMoreVisible = !this.isMoreVisible;
    },
    handleDocumentClick(event) {
      // Check if the clicked element is inside the sidebar
      if (
        event.target.closest(".sidebar") ||
        event.target === this.$refs.openSidebar
      ) {
        return;
      }
      // The clicked element is outside the sidebar, so close it
      this.isSidebarToggle = false;
    },
  },

  watch: {
    isSidebarToggle: function (val) {
      // Add the 'sidebar-open' class to the body when the sidebar is open
      document.body.classList.toggle("sidebar-open", val);

      // If the sidebar is now open, add a click event listener to the document
      if (val) {
        document.addEventListener("click", this.handleOutsideClick);
      } else {
        document.removeEventListener("click", this.handleOutsideClick);
      }
    },
  },
};
</script>

<style>
.st2 {
  fill: #fff;
}

.dropdown-content {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #fff;
  border: 1px solid #ccc;
  z-index: 10; /* set a lower z-index value than the button */
  opacity: 0; /* hide the dropdown by default */
  transform: translateY(-10px); /* move the dropdown up by 10 pixels */
  transition: opacity 0.2s ease, transform 0.2s ease; /* add a transition for smooth animation */
}

.dropdown:hover .dropdown-content {
  opacity: 1; /* show the dropdown when the button is hovered */
  transform: translateY(
    0
  ); /* move the dropdown down to its original position */
  z-index: 20; /* set a higher z-index value than the button */
}

.sidebar {
  position: relative;
}

.sidebar {
  position: absolute;
  top: 0;
  right: 0;
  width: 320px;
  border-radius: 25px 0 0 25px; /* top-left and bottom-left */
  height: 100%;
  transform: translateX(100%);
  transition: transform 0.3s ease-in-out;
  z-index: 11;
}

.sidebarOpen {
  transform: translateX(0%);
}

/* Add this CSS to hide the scrollbar when the sidebar is open */
body.sidebar-open {
  overflow-y: hidden;
}

#mobileEarnArrow,
#mobileMoreArrow {
  transition: transform 0.3s ease; /* Add a 0.3s transition with ease timing function */
}
</style>
